import React, { FC, useState } from 'react'
import { Button, Col, Row } from 'antd'
import { Reseller, ResellerFormValues } from '../../../types'
import styles from './index.module.less'
import { ResellerAccountForm } from '../../../components'
import { useAuth } from '../../../providers/AuthProvider'

interface AccountProps {
	reseller: Reseller
	submit(values: ResellerFormValues): Promise<void>
	editable?: boolean
}

const Account: FC<AccountProps> = ({ reseller, submit, editable = true }) => {
	const { userHasPermission } = useAuth()
	const [isEditMode, setEditMode] = useState<boolean>(false)

	const onSubmit = async (values: ResellerFormValues) => {
		await submit(values)
		setEditMode(false)
	}

	const DisplayView = () => (
		<Row type='flex' justify='space-between'>
			<Col>
				<dl>
					<dt>Name:</dt>
					<dd className={styles.detailLabel}>{reseller?.name}</dd>
					<dt>Email:</dt>
					<dd className={styles.detailLabel}>{reseller?.email}</dd>
					<dt>Phone Number:</dt>
					<dd className={styles.detailLabel}>{reseller?.phone_number}</dd>
					<dt>Address:</dt>
					<dd>
						<span>{reseller?.address1}</span>
						<br />
						<span>{reseller?.address2}</span>
						<br />
						<span>{reseller?.postcode}</span>
					</dd>
					{reseller?.distributor && userHasPermission(['ServiceProvider.All.ReadWrite']) ? (
						<>
							<dt>Distributor:</dt>
							<dd className={styles.detailLabel}>{reseller?.distributor}</dd>
						</>
					) : null}
				</dl>
			</Col>
			{editable ? (
				<Col>
					<Button icon={'edit'} onClick={() => setEditMode(true)}>
						Edit {reseller.name}
					</Button>
				</Col>
			) : null}
		</Row>
	)

	return !isEditMode ? (
		<DisplayView />
	) : (
		<Row>
			<Col lg={24} xl={20} xxl={12}>
				<ResellerAccountForm reseller={reseller} submit={onSubmit} cancel={() => setEditMode(false)} />
			</Col>
		</Row>
	)
}

export default Account
